import { typedQueryClient, useTypedQuery } from "hooks";
import { ROLES, USER_STATUSES } from "models";
import { UsersKeys } from "modules/Users/queryKeys";

export type UsersFilters = {
  role_id: ROLES | null;
  user_status_id: USER_STATUSES | null;
  search_term: string;
  page: number;
  page_size: number;
};

const defaultData: UsersFilters = {
  page: 1,
  page_size: 25,
  role_id: null,
  user_status_id: null,
  search_term: ""
};

export const useUsersFilters = () => {
  const { data } = useTypedQuery({ queryKey: UsersKeys.filters, initialData: defaultData });
  return { filters: data };
};

export const useUsersFiltersUpdate = () => {
  const { filters } = useUsersFilters();
  return (newFilters: Partial<UsersFilters>) => typedQueryClient.setQueryData(UsersKeys.filters, { ...filters, ...newFilters });
};
